import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Top.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';


function TopNav() {

    return <>
    <Navbar bg="dark" expand="lg" data-bs-theme="dark">
        <Container>
        <Navbar.Brand>Лаборатория</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav variant="pills" className="flex-row">
            <Nav.Link 
                as={NavLink} 
                to="/home">
                Главная
            </Nav.Link>
            <Nav.Link 
                as={NavLink} 
                to="/lingvo">
                Лингвистика
            </Nav.Link>
                <NavDropdown title="Изображения" 
                    id="basic-nav-dropdown" 
                    >
                        <NavDropdown.Item as={NavLink} to="/images/face">Face detect</NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="/images/object">Object detect</NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="/images/ocr">OCR</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                </NavDropdown>
            </Nav>
        </Navbar.Collapse>
        </Container>
    </Navbar>
    </>
}

export default TopNav;
